import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Input } from "reactstrap";

interface CopyWrapperProps {
  item?: any;
  valueDefault: string;
  rewardNoteEdit?: any;
  handleUpdateRewardOnGrid?: any;
  setRewardNoteEdit?: any;
}

const InputUpdateOnGrid: React.FC<CopyWrapperProps> = ({
  item,
  valueDefault,
  rewardNoteEdit,
  handleUpdateRewardOnGrid,
  setRewardNoteEdit
}) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState<string>("");

  const handleChangeInput = (event: any) => {
    setInputValue(event?.target?.value);
  }

  useEffect(() => {
    if (valueDefault) {
      setInputValue(valueDefault);
    }
  }, [valueDefault]);


  return (
    <div className="d-flex align-items-center gap-1 justify-content-left">
      <Input
        name="note"
        type="text"
        className="form-control"
        placeholder={t("Note")}
        value={inputValue}
        onChange={handleChangeInput}
      />

      <div
        className={`ms-1 cursor-pointer ${rewardNoteEdit === item?.id ? "d-block" : "d-none"}`}
        onClick={() => {
          handleUpdateRewardOnGrid(rewardNoteEdit, 'note', inputValue)
        }}
      >
        <i
          className="ri-check-fill text-primary"
          style={{ fontSize: "16px", fontWeight: 700 }}
        ></i>
      </div>

      <div
        className={`ms-1 cursor-pointer ${rewardNoteEdit === item?.id ? "d-block" : "d-none"}`}
        onClick={() => setRewardNoteEdit(false)}
      >
        <i
          className="ri-close-circle-fill text-primary"
          style={{ fontSize: "16px" }}
        ></i>
      </div>
    </div>
  );
};

export default InputUpdateOnGrid;
